import * as act from "../actions/actiontypes";

const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = window.document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
const initState = {
  user: {
    // token: localStorage.getItem("utoken"),
    token: getCookie("token") || localStorage.getItem("utoken") || localStorage.getItem("token"),
    type: localStorage.getItem("utype"),
    data: {
      user_id: {},
    },
  },
  subscriptionData: {},
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case act.LOGIN_SUCCESS:
      const { token, type } = action.user;
      return {
        ...state,
        user: {
          ...state.user,
          token,
          type,
        },
      };

    case act.USER_DATA_SUCCESS:
      const {
        data,
        referalcode,
        referals,
        taketest,
        ikigai,
        giverstatus,
        seekerstatus,
        isindianuser,
        aproved,
      } = action.user;
      if (data.user_type === "both")
        return {
          ...state,
          user: {
            ...state.user,
            data: {
              ...data,
              user_id: {
                id: data.id,
                email: data.email,
                mobile: data.mobile,
                gender: data.gender,
                aproved: data.aproved,
                wallet: data.wallet,
                age: data.age,
                user_type: data.user_type,
              },
            },
            referalcode,
            referals,
            taketest,
            ikigai,
            seekerstatus,
            giverstatus,
            isindianuser,
            aproved,
          },
        };
      else
        return {
          ...state,
          user: {
            ...state.user,
            data,
            referalcode,
            referals,
            taketest,
            ikigai,
            isindianuser,
            aproved
          },
        };
    case act.FORGOT_PASSWORD:
      return {
        ...state,
        user: {
          ...state.user,
          forgotpassword: {
            token: action.token,
          },
        },
      };

    case act.PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          forgotpassword: {},
        },
      };

    case act.REPORT_DATA_SUCCESS:
      const { reportData } = action;
      return {
        ...state,
        user: {
          ...state.user,
          reportData,
        },
      };
    case act.SET_P_TOKEN:
      return {
        ...state,
        user: {
          ...state.user,
          ptoken: action.token,
        },
      };
    case act.CLEAR_MY_DATA:
      return {
        ...state,
        user: {},
      };
    default:
      return state;
  }
};
export default userReducer;
